export const actionTypes = {
  SET_BREAKAGEANDRETURN: "SET_BREAKAGEANDRETURN",
  SET_BREAKAGEANDRETURN_FILTERED: "SET_BREAKAGEANDRETURN_FILTERED",
  SET_FILTER: "SET_FILTER",
  SET_FILTER_DEFAULTS: "SET_FILTER_DEFAULTS",
  SET_LOADING: "SET_LOADING",
};
